/**
 * Cursors record DTO
 */
export class CursorsRecordDto {
	name!: string;
	lastValue!: number;
}
